import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from './components/ConfigContext.js';
import './index.css';
import './tailwind.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import './utils/utmKeeper.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <ConfigProvider>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
